/**
 * Which build this is (2 Nov UAT: testers couldn't say which version they were on). Baked in by Vite at BUILD time
 * (vite.config.ts `define`) from apps/web/package.json and the FYR_GIT_SHA / FYR_BUILD_DATE build args the image is
 * built with — the web bundle is the one source of truth; nothing asks git or the api at runtime. Local dev shows "dev".
 */
declare const __FYR_BUILD__: { version: string; commit: string; date: string } | undefined;

export const BUILD =
  typeof __FYR_BUILD__ !== 'undefined' ? __FYR_BUILD__ : { version: '0.0.0', commit: 'dev', date: '' };

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-11-02" → "02 Nov 2026" (fixed English: it's an identifier people paste into defect reports). */
export function buildDateLabel(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return iso;
  return `${m[3]} ${MONTHS[Number(m[2]) - 1] ?? m[2]} ${m[1]}`;
}

/** "Fyr 0.1.0 · 3f9c2ab · 02 Nov 2026" */
export function buildLabel(b = BUILD): string {
  return [`Fyr ${b.version}`, b.commit, b.date && buildDateLabel(b.date)].filter(Boolean).join(' · ');
}
